<template>
  <div class="vcontainer">
    <van-row>
      <van-col span="24" >
        <video
          v-if="video && video.filelink && playerType === 'video'"
          id="player"
          :src="video.filelink"
          controls="controls"
          controlslist="nodownload"
          :style="playerstyle"
          :autoplay="autoplay"
          webkit-playsinline="true"
          playsinline="true"
        ></video>
        <audio
          v-else-if="video && video.filelink && playerType === 'audio'"
          id="player2"
          :src="video.filelink"
          controls="controls"
          controlslist="nodownload"
          :style="playerstyle"
          :autoplay="autoplay"
          webkit-playsinline="true"
          playsinline="true"
        ></audio>
        <!-- https://study-client.bailianda.com.cn/minio/media/wbSchoolFile/1737613589464_%E6%89%A7%E8%A1%8C-%E4%BA%94%E6%98%9F%E6%89%A7%E8%A1%8C%E5%8A%9B.pdf -->
        <pdf 
          style="width: 100%;height: 550px;overflow-y: scroll;"
          v-else-if="video && video.filelink && playerType === 'pdf'"
          :src="video.filelink"></pdf>
        <iframe
          v-else-if="video && video.filelink && playerType === 'frame'"
          id="myiframe"
          ref="myiframe"
          :src="video.filelink + '#navpanes=0'"
          style="width: 100%;height: 450px"
        ></iframe>
        <div
          style="display:block;background-color:black;width:100%;min-height:200px"
          v-else-if="video && video.filelink && playerType === 'tvideo'"
        >
          <tc-player-w
            v-if="video && video.filelink && playerType === 'tvideo'"
            :file_id="video.filelink"
            :auto="autoplay"
            @ended="closetimer"
            @play="onplay"
          />
        </div>
        <div
          v-else-if="video && video.filelink && playerType === 'img'"
          style="display:block;background-color:black;width:100%;height:200px"
        >
          <img :src="info.bg" style="width:100%;height:100%" />
        </div>
      </van-col>
    </van-row>
    <van-row v-if="info.title" class="ctitle">
      <div>
        <span :class="info.cert_info?null:tclass" :style="tagStyle">{{ info.title }}</span>
        <van-tag  plain type="warning" v-if="playerType === 'audio'">音频</van-tag>
      </div>
    </van-row>
    <!-- <div v-if="info.id" style="display: flex;justify-content: right">
      <van-button type="danger" size="small" plain @click="toAssessmentPage()"   style="margin-right: 10px">前去考试</van-button>
    </div> -->
    <van-divider :style="{ borderColor: '#f00' }" />

    <template v-if="info.image_url">
      <van-tabs  class="myTabTitle" v-model:active="active2" shrink type="card" :border="true" style="padding-top:10px"   color="#f00">
        <van-tab title="课件列表" >
          <van-row  class="clist" style="padding: 20px 0px">
            <div
              v-for="(line, index) of info.file_list"
              :key="line.fileId"
              :class="line.end_time?'finish':''"
            >
              <div :class="getlineclass(index)" @click="changeLine(line, index)" >{{ line.filename }}</div>

              <van-divider />
            </div>
          </van-row>
        </van-tab>
        <van-tab title="简介">
          <img v-if="info.image_url" :src="info.image_url" style="width:100%;height:auto" />
          <div v-else>本视频暂无简介</div>
        </van-tab>
        <van-tab title="评价">
          <div v-if="this.info.rank>0" style="padding-top: 10px;padding-left: 10px;text-align: center" >
            <van-rate v-model="fileStarvalue" allow-half void-icon="star" void-color="#eee"   color="#ee0a24"  readonly  />
            <span style="padding-left:3px;font-size: 18px;line-height: 18px">{{this.info.rank?this.info.rank.toFixed(2):0}}分</span>
          </div>
          <div v-else style="padding-top: 10px;padding-left: 10px;text-align: center;font-size: 18px">
            暂无评价
          </div>
        </van-tab>
      </van-tabs>

      <van-tabbar :fixed="true" v-if="(info.channel_type=='hrsecn'||info.channel_type=='keqq')&&info.buy">
        <van-button type="danger"  size="large" @click="toBuyed(info)"  >查看详情</van-button>
      </van-tabbar>
    </template>
    <van-tabs  class="myTabTitle" v-else-if="info.mediadesc" v-model:active="active" shrink type="card" :border="true" style="padding-top:10px"   color="#f00">
      <van-tab title="课件列表" >
        <van-row  class="clist" style="padding: 20px 0px">
          <div
            v-for="(line, index) of list"
            :key="line.fileId"
           
            :class="line.end_time?'finish':''"
          >
            <div :class="getlineclass(index)"  @click="changeLine(line, index)">{{ line.filename }}</div>
            <van-divider />
          </div>
        </van-row>
      </van-tab>
      <van-tab title="简介">
        <van-row  v-if="info.mediadesc&&info.channel_type!='hrsecn'" class="cdesc" style="padding: 20px 10px">
          <div v-html="info.mediadesc">{{ info.mediadesc }}</div>
          <!--<div>{{ info.mediadesc }}</div>-->
        </van-row>
        <div v-else>本视频暂无简介</div>
      </van-tab>
      <van-tab title="评价">
        <div v-if="this.info.rank>0" style="padding-top: 10px;padding-left: 10px;text-align: center">
          <van-rate v-model="fileStarvalue" allow-half void-icon="star" void-color="#eee"   color="#ee0a24"  readonly  />
          <span  style="padding-left:3px;font-size: 18px;line-height: 18px">{{this.info.rank?this.info.rank.toFixed(2):0}}分</span>
        </div>
        <div v-else style="padding-top: 10px;padding-left: 10px;text-align: center;font-size: 18px">
          暂无评价
        </div>
      </van-tab>
      <van-dialog
        v-model="showRate"
        title="评价"
        show-cancel-button
        @confirm="evaluate()"
        @cancel="cancelPJ()"
        confirmButtonText="提交"
      >
        <div style="padding-left: 20px;padding-top: 4px">
          <van-rate v-model="evaluateObj.rank"  void-icon="star" void-color="#eee"   color="#ee0a24"    />
        </div>
        <van-field
          v-model="evaluateObj.info"
          rows="3"
          autosize
          label="留言"
          type="textarea"
          maxlength="100"
          placeholder="请输入留言"
          show-word-limit
        />
      </van-dialog>
    </van-tabs>
  </div>
</template>
<script>
import { getFile, startTracePlay, updateTracePlay,getDetail,mediaInfoRank } from '@/api/shopapi'
import TcPlayerW from './tcplayerw'
import pdf from './pdf.vue'
import moment from 'moment'
export default {
  name: 'PlayVideo',
  components:{
    TcPlayerW,
    pdf
  },
  data () {
    return {
      learn: {},
      info: {},
      list: [],
      video: {},
      selectpos: 0,
      vindeoindex: 0,
      timer: null,
      lastdurition: 0,
      autoplay: false,
      user_media_play_id: 0,
      loading: false,
      options: [],
      myToast:null,
      active:0,
      active2:0,
      showRate:false,
      evaluateObj:{
        rank:0,
        info:''
      },
      firstFlag:true
    }
  },
  computed: {
    tclass () {
      if(this.info.try_time > 0 ) {
        return ['ttitle']
      }
      return []
    },
    tagStyle(){
      return {
        paddingRight:'2px' ,
      }
    },
    playerstyle () {
      try {
        if(this.video && this.video.filelink.indexOf('.mp3') !== -1) {
          return { width: '100%', height: '40px' }
        }else{
          return { width: '100%'}
        }
      } catch (e) {
        console.log(e)
      }
      return { width: '100%', height: 'auto' }
    },
    hasListener () {
      return this.playerType === 'audio' || this.playerType === 'video'
    },
    playerType(){
      try {
        // if(this.info.linktype === 3) {
        //   return 'frame'
        // }
        // if(this.info.videoType === 1) {
        //   return 'tvideo'
        // }
        if(this.video && (this.video.filelink?.indexOf('.mp3') !== -1 || this.video.filelink?.indexOf('.mkv') !== -1)) {
          return 'audio'
        }
        if(this.video && this.video.filelink?.indexOf('.pdf') !== -1){
          return 'pdf'
        }
        // if(this.video && (this.video.filelink.indexOf('.pdf') !== -1 || 
        //   this.video.filelink.indexOf('.docx') !== -1 || 
        //   this.video.filelink.indexOf('.xlxs') !== -1 ||
        //   ['.png', '.jpg', '.jpeg', '.bmp', '.gif'].indexOf(this.video.filelink.substr(this.video.filelink.lastIndexOf('.')).toLowerCase()) !== -1)) {
        //   return 'frame'
        // }
        // if (this.video.filelink.indexOf('.docx') !== -1 || this.video.filelink.indexOf('.xlxs') !== -1 ||) {
        //   return 'docx'
        // } 
        if (this.video && ['.png', '.jpg', '.jpeg', '.bmp', '.gif'].indexOf(this.video.filelink?.substr(this.video.filelink?.lastIndexOf('.')).toLowerCase()) !== -1) {
          return 'img'
        }
      } catch (e) {
        console.log('error',e)
      }
      return 'video'
    },
    playerId () {
      try {
        if(this.video && this.video.filelink?.indexOf('.mp3') !== -1) {
          console.log('audio')
          return "player2"
        }
      } catch (e) {}
      return "player"
    },
    fileStarvalue(){
      return this.info.rank?this.info.rank:0
    }
  },
  beforeDestroy () {
    console.log('dispose player')
    if(this.timer)
      clearInterval(this.timer)
  },
  async mounted () {
    const playerid = this.$store.getters.getPlayID
    const id = this.$route.params.id || playerid.id
    
    console.log(this.$route.params);
    
    if(!id) {
      this.$router.replace({ path: "/school" })
      return
    }else{
      this.$store.dispatch("setPlayId",{
        id: id,
        file_id: this.$route.params.last_play?.file_id || playerid.file_id,
        file_position: this.$route.params.last_play?.file_position || playerid.file_position,
      });
    }
    this.learn = {
      file_id: this.$route.params.last_play?.file_id || playerid.file_id,
      file_position: this.$route.params.last_play?.file_position || playerid.file_position,
    }
    console.log(this.learn);
    const { data } = await getDetail({info_id:id})
    this.info = data
    if(!this.info || !this.info.id){
      this.$router.replace({ path: "/school" })
      return
    }
    if(this.info.info_play_rate>95&&!this.info.user_rank){
      this.showRate=true
    }else{
      this.firstFlag=false
    }
    this.startGetFile()

  },
  methods: {
    changeLine (line, index) {
      this.changefile(line, index)
    },
    onplay (tcv){
      if(this.info.channel_type!=='keqq'){
        const myVideo = document.getElementById(this.playerId)
        const pos = myVideo.currentTime
        startTracePlay({
          file_id: this.video.fileId,
          info_id: this.info.id
        }).then(res=>{
          if(res && res.code === '000' && res.data && res.data.user_media_play_id) {
            this.inittimer(res.data.user_media_play_id, tcv)
          }else if (pos >= this.info.try_time){
            this.$toast.fail({
              duration: 3000, // 持续展示 toast
              forbidClick: true,
              message: `播放失败！${res.message}`
            });
            this.loading = false
          }
        })
      }
    },
    closetimer (tcv) {
      try {
        console.log('start closetimer',tcv?1:0)
        const myVideo = tcv || document.getElementById(this.playerId)
        if(myVideo) {
          console.log('get myVideo',tcv?1:0)
          if(this.timer) {
            console.log('get timer',tcv?1:0)
            clearInterval(this.timer)
            console.log('clear timter',tcv?1:0)
            if(myVideo && !tcv) {
              try {
                const pos = tcv ? myVideo.children_[0].currentTime : myVideo.currentTime
                console.log('close pos', pos)
                updateTracePlay({
                  position: pos,
                  user_media_play_id: this.user_media_play_id
                }, false)
              } catch (e) {
                console.log(e)
              }
            }
            console.log('clearInterval',tcv?1:0)
            this.timer = null
            this.user_media_play_id = 0
          }
          return myVideo
        }
      } catch (e) {
        console.error('closetimer error', e)
      }
      return null
    },
    inittimer (user_media_play_id,tcv) {
      console.log('start inittimer',tcv?1:0)
      const myVideo = this.closetimer(tcv)
      if(myVideo) {
        console.log('inittimer getVideo',tcv?1:0)
        this.user_media_play_id = user_media_play_id
        this.lastdurition = 0
        this.timer = setInterval(()=>{
          try {
            const pos = tcv ? myVideo.children_[0].currentTime : myVideo.currentTime
            console.log('pos', pos)
            if(pos !== this.lastdurition) {
              this.lastdurition = pos
              updateTracePlay({
                position: this.lastdurition,
                user_media_play_id: this.user_media_play_id
              })
            }
          } catch (e) {
            console.log(e)
          }
        }, 5 * 1000)
      }
    },
    pauseVideoL (e) {
      console.log('暂停播放',e)
    },
    playVideoL (e) {
      console.log('提示该视频正在播放中',e)
      const myVideo = document.getElementById(this.playerId)
      const pos = myVideo.currentTime
      startTracePlay({
        file_id: this.video.fileId,
        info_id: this.info.id
      }).then(res=>{
        if(res && res.code === '000' && res.data && res.data.user_media_play_id) {
          this.inittimer(res.data.user_media_play_id)
        }else if (pos >= this.info.try_time) {
         if(this.info.try_time==0){
            let that=this
            const myVideo = document.getElementById(this.playerId)
            myVideo.pause()
            this.$toast.fail({
              duration: 3000, // 持续展示 toast
              forbidClick: true,
              message: `播放失败！${res.message}`,
              onClose:function(){
                // that.$router.go(-1);
              }
            });
         }
        }
      })
    },
    errorL (e) {
      console.log('视频出错了',e)
      this.closetimer()
      console.log('stop erro myToast')
      this.myToast.clear()
    },
    async endedL (e) {
      console.log('视频播放完了',e)
      console.log('视频播放完了',this.video)
      console.log('视频播放完了3',this.list)
      if(this.info.info_play_rate>85&&!this.info.user_rank){
        this.showRate=true
      }else{
        const id = this.$route.params.id || playerid.id
        const { data } = await getDetail({info_id:id})
        let info = data
        console.log('infodd',info)
        if(this.info.info_play_rate>85&&!this.info.user_rank){
          this.showRate=true
        }else{
          this.doendedL()
        }
      }
    },
    doendedL(){
      try{
        this.list.map(v=>{
          if(v.fileId==this.video.fileId){
            v.end_time=Date()
          }
        })
      }catch (e) {
        console.log(e)
      }
      updateTracePlay({
        position: this.lastdurition,
        user_media_play_id: this.user_media_play_id,
        end:true
      })
      this.closetimer()
      if(this.vindeoindex < this.list.length - 1){
        const index = this.vindeoindex+1
        const line = this.list[index]
        this.changeLine(line, index)
      }
    },
    timeupdate (e) {
      if (this.info.try_time > 0) {
        const myVideo = document.getElementById(this.playerId)
        const pos = myVideo.currentTime
        if (pos >= this.info.try_time) {
          const index = this.vindeoindex
          const line = this.list[index]
          myVideo.pause()
          this.changefile(line, index, 1)
        }
      }
    },
    initlistener (first) {
      console.log('ppppppppppppppp');
      
      if(!this.hasListener)
        return
      try {
        const that = this
        const myVideo = document.getElementById(this.playerId)
        console.log('myVideo',myVideo)
        if(myVideo && first) {
          this.myToast = this.$toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
            overlay:true
          })
          console.log('start myToast!')
          myVideo.removeEventListener('play', this.playVideoL)
          myVideo.removeEventListener('pause', this.pauseVideoL)
          myVideo.removeEventListener('error', this.endedL)
          myVideo.removeEventListener('error', this.errorL)
          myVideo.removeEventListener('timeupdate', this.timeupdate)

          myVideo.addEventListener('play',this.playVideoL)
          myVideo.addEventListener('pause', this.pauseVideoL)
          myVideo.addEventListener('ended', this.endedL)
          myVideo.addEventListener('error', this.errorL)
          myVideo.addEventListener('timeupdate', this.timeupdate)
        }
        console.log('end initlistener')
        if (first) {
          console.log(this.learn);
          
          if(this.learn.file_id && this.learn.file_position) {
            console.log('this.list', this.list)
            const st = this.list.find(f=>f.fileId === this.learn.file_id)
            const idx = this.list.findIndex(f=>f.fileId === this.learn.file_id)
            this.$nextTick(() => {
              this.changefile(st,idx,this.learn.file_position)
            });
          }else{
            console.log('stop no lear myToast')
            if(this.myToast){
              this.myToast.clear()
            }
          }
        } else {
          this.$nextTick(()=>{
            this.autoplay = true
            console.log('start autoplay')
          })
        }
      } catch (e) {
        console.error('initlistener', e)
      }
    },
    getlineclassX () {
      return ['cline']
    },
    getlineclass (index) {
      const base = this.getlineclassX()
      if (this.vindeoindex === index) {
        base.push('playnow')
      }
      return base
    },
    stopvideo () {
      try {
        console.log('start stopvideo!')
        const myVideo = this.closetimer()
        console.log('stopmyVideo', myVideo)
        if(myVideo){
          console.log('video paused!')
          myVideo.pause()
          return myVideo
        }
      } catch (e) {
        console.error('stopvideo', e)
      }
    },
    changefileTc (info, index) {
      this.video = {}
      this.myToast.clear()
      console.log('stop tc myToast!')
      this.$nextTick(()=>{
        this.autoplay = true
        this.vindeoindex = index
        this.video = info
        console.log('newvideo', this.video)
      })
    },
    videoPos (e) {
      const myVideo = document.getElementById(this.playerId)
      if(myVideo.paused || myVideo.ended) {
        myVideo.currentTime = this.selectpos
        console.log('canplay',e)
        console.log('need setpos to '+ this.selectpos)
        console.log('setpos to '+ myVideo.currentTime)
        myVideo.play()
        this.selectpos = 0
      }
      this.myToast.clear()
      console.log('stop pos myToast!')
    },
    changefile (info, index, pos) {
      console.log('start changefile')
      if (this.playerType === 'tvideo') {
        console.log('tc video!')
        this.changefileTc(info,index,pos)
      } else {
        console.log(info,'opopo')
        if(info && info.filelink) {
          if(this.video.fileId === info.fileId) {
            const myVideo = document.getElementById(this.playerId)
            if(!myVideo){
              console.log('stop no element myToast!')
              this.myToast.clear()
              return
            }
            if(myVideo.paused || myVideo.ended) {
              if (pos) {
                try {
                  this.selectpos = pos
                  myVideo.removeEventListener('canplay',this.videoPos)
                  myVideo.addEventListener('canplay', this.videoPos)
                  myVideo.load()
                } catch (e) {
                  console.log(e)
                }
              }else{
                console.log('auto play !!')
                myVideo.play()
              }
            } else if(!myVideo.paused){
              console.log('pause video !!')
              myVideo.pause()
              this.myToast.clear()
            } else{
              this.myToast.clear()
              console.log('stop new myToast!')
            }
          } else {
            console.log('no file!',info)
            const myVideo = document.getElementById(this.playerId)
            this.stopvideo()
            this.vindeoindex = index
            this.video = info
            this.$nextTick(async()=>{
              const { data } = await getDetail({info_id:this.$route.params.id})
             
              myVideo.currentTime =  data.file_list[index].position
              this.initlistener()
            })
          }
        }else{
          this.myToast.clear()
        }
      }
    },
    toAssessmentPage(){
      this.$store.dispatch("setExamType",13)
      this.$router.push({
        path: '/exam',
        query:{
          info_id:this.info.id
        }
      })
    },
    async startGetFile(){
      const res = await getFile({ info_id: this.info.id })
      if(res.data && res.code === '000'){
        this.list = res.data
        console.log('res.datares.datares.datares.data',res.data)
        if(this.learn) {
          for (let i = 0; i < this.list.length ; i++) {
            if(this.list[i].fileId === this.learn.file_id) {
              this.vindeoindex = i
              break
            }
          }
        }
        this.video = this.list[this.vindeoindex]
        console.log('this.video ',this.video )
        console.log('this.playerTypethis.playerType',this.playerType)
        if(this.playerType=='img'||this.playerType=='frame'||this.playerType=='richText'||this.playerType=='pdf'){
          if(this.info.try_time==0){
            startTracePlay({
              file_id: this.video.fileId,
              info_id: this.info.id
            }).then(res=>{
              if(res && res.code === '000') {
                console.log('resresres',res)
                this.inittimer(res.data.user_media_play_id)
              }else if(this.info.try_time==0){
                console.log('33333222')
                let that=this
                const myVideo = document.getElementById(this.playerId)
                myVideo.pause()
                this.$toast.fail({
                  duration: 3000, // 持续展示 toast
                  forbidClick: true,
                  message: `播放失败！${res.message}`,
                  onClose:function(){
                    console.log('11111')
                    // that.$router.go(-1);
                  }
                });
              }
            })
          }
        }
        this.info.mediadesc = this.info.mediadesc || '本视频暂无简介;'
        this.$nextTick(()=>{
          console.log('first initlistener')
          this.initlistener(true)
        })
      }
    },
    evaluate(){
      if(this.firstFlag){
        let para={
          info:this.evaluateObj.info,
          info_id: this.info.id,
          rank: this.evaluateObj.rank
        }
        mediaInfoRank(para).then( res=>{
          console.log('res',res)
          if(res.code==='000'){
            let _this=this
            this.$toast.success({
              duration:2000,
              message: '感谢您的课程反馈',
              onClose:function(){
                _this.firstFlag=false
                _this.startGetFile()
              }
            })
          }else{
            this.$toast.success({
              duration:2000,
              message: res.message,
              onClose:function(){
                _this.firstFlag=false
                _this.startGetFile()
              }
            })
          }
        })

      }else{
        this.doendedL()
      }
    },
    cancelPJ(){
      if(this.firstFlag){
        this.firstFlag=false
        this.startGetFile()
      }else{
        this.doendedL()
      }
    }
  }
}
</script>
<style>
.ctitle::before {
  display: block;
  position: absolute;
  color: red;
  text-align: center;
  font-weight: 500;
  font-size: 0.5rem;
  line-height: 0.56rem;
  height: 0.56rem;
  width: 30px;
  content: "●";
  left: 0px;
}
.ctitle {
  color: black;
  padding: 10px 30px;
  text-align: left;
  font-weight: 500;
  font-size: 0.53rem;
  line-height: 0.56rem;
  display: block;
  position: relative;
  height: auto;
}
.cprice {
  flex: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 30px;
  justify-items: center;
  position: relative;
  height: auto;
}
.cdesc {
  flex: 1;
  color: black;
  padding: 0px 30px;
  text-align: left;
  font-weight: lighter;
  font-size: 0.33rem;
  line-height: 0.4rem;
  max-height:40rem;
  overflow-y: scroll;
}
.clist {
  flex: 1;
  display: flex;
  flex-direction: column;
  color: black;
  padding: 10px 0px;
  text-align: left;
  font-weight: 400;
  font-size: 0.43rem;
  line-height: 0.5rem;
  overflow-y: scroll;
}
.cline {
  display: block;
  position: relative;
  width: auto;
  padding: 0px 40px 0 30px;
}
.needpay {
  font-weight: lighter;
  text-decoration: line-through;
}
.playnow {
  color: red;
}
.playnow::before {
  display: block;
  position: absolute;
  color: red;
  text-align: center;
  content: "📺";
  width: 30px;
  left: 0;
  top: 0;
}
.notvip::before {
  display: block;
  position: absolute;
  color: red;
  text-align: center;
  padding: 5px;
  content: "VIP";
  border-radius: 15px;
  right: 0px;
  top: -5px;
  margin-right: 10px;
}
.vcontainer {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 46px);
}
.titles {
  font-weight: bold;
  font-size: 16px;
  padding: 10px 0;
  text-align: center;
}
.origin {
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.richtextimg {
  width: 100% !important;
  height: auto !important;
}
.richText img {
  width: 100% !important;
}
  .finish{
    color: #a6a6a6;
  }
.address {
  padding-top: 17px;
  position: relative;
  background-color: #fff;
}
.address::after {
  content: '';
  display: block;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #3283fa 0, #3283fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #3283fa 0, #3283fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
}

.address-item {
  padding:5px 5px!important;
}
.user-info {
  margin-left: 10px;
  font-weight: bold;
}

.phonenum {
  float: right;
  margin-right: 20px;
}

.address-bottom{
  margin-top: 6px
}
.address-bottom  .address-info {
  font-size: 14px;
  margin-left: 24px;
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}


.next-icon {
  position: absolute;
  right: 10px;
  top: 46px
}
.next-icon   i {
  font-weight: bold;
  color: #888
}
.wantS{
  display: -webkit-box; /* mate8 支持 */
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  justify-content: right;
  padding-right: 10px
}

</style>
<style  scoped>
  .myActionSheet{
    height: 50vh;
    padding-bottom: 50px;
  }
  @media screen and (max-height: 600px) {
    .myActionSheet{
      height: 75vh;
    }
  }

  .myTabTitle >>>.van-tabs__nav{
    margin: 0px 6px
  }
</style>
